import React from 'react';
import type NextGenReportsBurndownType from '@atlassian/jira-spa-apps-next-gen-reports-burndown/src/index-old.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';
import { getBoardId } from '../../../../common/index.tsx';

/** @deprecated remove when clean up fun-1593-migrate-burndown-report-to-entrypoint */
export const LazyNextGenBurndownReport = lazyForPaint<typeof NextGenReportsBurndownType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-next-gen-reports-burndown", jiraSpaEntry: "next-gen-reports-burndown" */ '@atlassian/jira-spa-apps-next-gen-reports-burndown/src/index-old.tsx'
		),
	),
);

type Props = RouteContext;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ location, match }: Props) => (
	<LazyPage
		Page={LazyNextGenBurndownReport}
		pageId={`next-gen-reports-burndown-${getBoardId({ location, match })}`}
		shouldShowSpinner={false}
	/>
);
